import React from "react"
import Grid from '@mui/material/Unstable_Grid2'
import Box from '@mui/material/Box'
import Drawer from '@mui/material/Drawer'
import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import Stack from '@mui/material/Stack'
import Avatar from '@mui/material/Avatar'
import Button from "@mui/material/Button"
import Footer from "../footer/Footer"
import SvgIcon from '@mui/material/SvgIcon'
import IconButton from '@mui/material/IconButton'
import Menu from '@mui/material/Menu'
import MenuIcon from '@mui/icons-material/Menu'

import AvatarImage from "../misc/AvatarImage"
import imagePaths from "../../configuration/imagePaths"

import PageHome from "../pages/PageHome"
import PageAbout from "../pages/PageAbout"
import PageProjects from "../pages/PageProjects"
import PageContact from "../pages/PageContact"

import HighlightedButton from "../buttons/HighlightedButton"

import useStorePageIndexState from "../../stores/storePageIndexState"

import {useMediaQuery} from 'react-responsive'

// import HighlightBar from "../svg/HighlightBar"


const drawerWidth = 240;

export default function Layout(props) {

    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })

    const [selectedPage, setSelectedPage] = React.useState("");

    const highlightState = useStorePageIndexState((state) => state.highlightState)
    const setHighlightState = useStorePageIndexState((state) => state.setHighlightState)

    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleMenu = (event) => {
      setAnchorEl(event.currentTarget);
    }
  
    const handleClose = () => {
      setAnchorEl(null);
    }

    function handleClick(event) {
        // console.log(event.currentTarget.textContent)
        setSelectedPage(event.currentTarget.textContent)

        const lowerCasePage = event.currentTarget.textContent.toLowerCase()
        let myObj = {[lowerCasePage]: true}
        const newObject = {
            home: false,
            about: false,
            projects: false,
            contact: false,
            ...myObj,
        }

        setHighlightState(newObject)
        // console.log("newObject", newObject)
        handleClose()
    }

   function renderPage(page){
        switch(page) {
            case "":
                return <PageHome/>
            case "Home":
                return <PageHome/>
            case "About":
                return <PageAbout/>
            case "Projects":
                return <PageProjects/>
            case "Contact":
                return <PageContact/>
            default: 
                return <PageHome/>
        }
    }

    function renderMobileOptions(){
        return (<>
        {/* <Box> */}
          <AppBar position="absolute" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, p: 1 }}>
                <Toolbar>
                    <AvatarImage 
                        width={drawerWidth * 0.65}
                        
                    />
                    <Box sx={{ flexGrow: 1 }}>

                    </Box>
                    
                    <IconButton
                        size="large"
                        onClick={handleMenu}
                        color="inherit"
                    >
                        <MenuIcon/>
                    </IconButton>
                    <Menu
                        id="menu-appbar"
                        anchorEl={anchorEl}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        keepMounted
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                    >
                        <Stack
                            direction="column"
                            alignItems="center"
                        >
                            <HighlightedButton handleClick={handleClick} value={"Home"} highlight={highlightState.home}/>
                            <HighlightedButton handleClick={handleClick} value={"About"} highlight={highlightState.about}/>
                            <HighlightedButton handleClick={handleClick} value={"Projects"} highlight={highlightState.projects}/>
                            <HighlightedButton handleClick={handleClick} value={"Contact"} highlight={highlightState.contact}/>
                        </Stack>
                    </Menu>
                </Toolbar>
            </AppBar>
            {/* </Box> */}
        </>)
    }

    function renderDesktopOptions(){
        return (<>
            <Drawer
                variant="permanent"
                sx={{
                    width: drawerWidth,
                    flexShrink: 0,
                    [`& .MuiDrawer-paper`]: { 
                        width: drawerWidth, 
                        boxSizing: 'border-box', 
                        backgroundColor: "rgba(0,0,0,0)"
                    },   
                }}
            >     
                <Toolbar/>

                <Stack 
                    direction="column"
                    alignItems="center"
                    spacing={1}
                    sx={{ 
                        pb: 6,
                    }}
                >
                    <AvatarImage width={drawerWidth}/>
                </Stack>
                
                <Stack 
                    direction="column"
                    justifyContent="space-around"
                    alignItems="center"
                    spacing={4}
                >
                    <HighlightedButton handleClick={handleClick} value={"Home"} highlight={highlightState.home}/>
                    <HighlightedButton handleClick={handleClick} value={"About"} highlight={highlightState.about}/>
                    <HighlightedButton handleClick={handleClick} value={"Projects"} highlight={highlightState.projects}/>
                    <HighlightedButton handleClick={handleClick} value={"Contact"} highlight={highlightState.contact}/>

                </Stack>
            </Drawer>
        </>)
    }

    return <>
        <Box sx={{ display: 'flex' }}>
            {isTabletOrMobile ? renderMobileOptions() : renderDesktopOptions()}
            
            <Box component="main" sx={{ flexGrow: 1, mt: isTabletOrMobile ? 10 : 1}}>
                <Box sx={{ width:"100%"}}>
                    <Stack 
                        direction="row"
                        justifyContent="center"
                        alignItems="center"
                        spacing={2}
                    >
                        <Stack 
                            direction="column"
                            alignItems="center"
                            spacing={2}
                        >
                            {renderPage(selectedPage)}  

                            <Footer/>
                        </Stack>
                    </Stack>
                </Box>
            </Box>
        </Box>  
    </>
}